/* Brick & Board search (Typesense) - header instant results + full results page.
   Config comes from <script id="bb-search-config"> (snippets/bb-search-config.liquid). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('bb-search-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var COLL = CFG.collection || 'products';
  var PER_PAGE = 24;
  var FIELDS = 'id,handle,title,name,url,image,set,game,category,price,price_max,compare_at,in_stock,total_qty,condition_in_stock,variants,kind';

  /* ---------------- helpers ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var cents = Math.round(Number(v || 0) * 100);
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    var withComma = amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return amt.replace('.', ',');
      return withComma;
    }).replace(/<[^>]*>/g, '');
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function bt(s) { return String(s).replace(/[`\\]/g, '').trim(); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, me = this; clearTimeout(t); t = setTimeout(function () { fn.apply(me, a); }, ms); }; }
  function variants(d) { try { return JSON.parse(d.variants || '[]'); } catch (e) { return []; } }
  var COND_SHORT = { 'Near Mint': 'NM', 'Lightly Played': 'LP', 'Moderately Played': 'MP', 'Heavily Played': 'HP', 'Damaged': 'DMG' };
  var COND_ORDER = ['Near Mint', 'Lightly Played', 'Moderately Played', 'Heavily Played', 'Damaged'];

  // Relevance: exact collector number/SKU > exact name = card-name match for singles > name contains > title contains
  // > card type line (e.g. "Creature — Vampire") > rules text > flavor text (Magic singles, from Scryfall);
  // then in stock first; then Typesense text score. mode 'ac' (type-ahead) only adds the type line.
  function rankSort(q, mode) {
    var s = bt(q);
    if (!s || s === '*') return 'in_stock_rank:desc,created_at:desc';
    var t = '`' + s + '`';
    var e = '(collector_number:=' + t + ' || sku:=' + t + '):8,(name:=' + t + '):7,' +
      '(name:' + t + ' && kind:=[Single,Graded,graded]):7,(name:' + t + '):6,(title:' + t + '):5,(type_line:' + t + '*):3';
    if (mode !== 'ac') e += ',(oracle_text:' + t + '*):2,(flavor_text:' + t + '*):1';
    return '_eval([' + e + ']):desc,in_stock_rank:desc,_text_match:desc';
  }
  var SORTS = {
    featured: { label: 'Featured' },          // collection's own Shopify order (resolved in sortBy)
    relevance: { label: 'Most relevant' },
    best: { label: 'Best selling', sort: 'in_stock_rank:desc,best_rank(missing_values:last):desc,created_at:desc' },
    name_asc: { label: 'Alphabetically, A-Z', sort: 'in_stock_rank:desc,title:asc' },
    name_desc: { label: 'Alphabetically, Z-A', sort: 'in_stock_rank:desc,title:desc' },
    price_asc: { label: 'Price, low to high', sort: 'in_stock_rank:desc,price:asc' },
    price_desc: { label: 'Price, high to low', sort: 'in_stock_rank:desc,price:desc' },
    oldest: { label: 'Date, old to new', sort: 'in_stock_rank:desc,created_at:asc' },
    newest: { label: 'Date, new to old', sort: 'in_stock_rank:desc,created_at:desc' }
  };
  // Shopify collection sort order -> our sort ("Featured")
  var SHOPIFY_SORT = { 'best-selling': 'best', 'created-descending': 'newest', 'created-ascending': 'oldest', 'title-ascending': 'name_asc', 'title-descending': 'name_desc', 'price-ascending': 'price_asc', 'price-descending': 'price_desc' };
  var FEATURED = 'best';
  var MANUAL_SORT = 'manual_pos(missing_values:last):desc,created_at:desc';   // merchandised order (e.g. Events)
  function sortBy(k, q) {
    if (k === 'featured' && IS_COLL && FEATURED === 'manual') return MANUAL_SORT;
    if (k === 'featured') k = IS_COLL ? FEATURED : 'relevance';
    return k === 'relevance' || !SORTS[k] ? rankSort(q, 'full') : SORTS[k].sort;
  }
  // type-ahead ('ac') searches names + type line; the full results page also searches rules and flavor text
  // (card text: no typo tolerance, so a typo'd name isn't "found" in some unrelated card's rules text)
  function baseParams(q, mode) {
    var p = {
      q: bt(q) || '*',
      query_by: 'name,title,collector_number,sku,set,type_line,oracle_text,flavor_text',
      query_by_weights: '5,3,5,2,1,2,1,1',
      num_typos: '2,2,2,2,2,1,0,0',
      prioritize_exact_match: true,
      typo_tokens_threshold: 1,
      drop_tokens_threshold: 1
    };
    if (mode === 'ac') { p.query_by = 'name,title,collector_number,sku,set,type_line'; p.query_by_weights = '5,3,5,2,1,2'; p.num_typos = '2,2,2,2,2,1'; }
    return p;
  }
  // "charzard" -> "charizard": if a typed word never matched exactly (or as a prefix), use the word the top hits matched instead
  function lev(a, b) {
    var m = a.length, n = b.length, d = [], i, j; if (Math.abs(m - n) > 2) return 9;
    for (i = 0; i <= m; i++) { d[i] = [i]; } for (j = 1; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[m][n];
  }
  function corrected(q, hits) {
    var words = bt(q).toLowerCase().split(/\s+/).filter(Boolean); if (!words.length || !hits || !hits.length) return '';
    var seen = {};
    hits.forEach(function (h) { var hl = h.highlight || {}; ['name', 'title', 'type_line', 'oracle_text', 'flavor_text'].forEach(function (f) { ((hl[f] || {}).matched_tokens || []).forEach(function (t) { t = String(t).toLowerCase(); seen[t] = (seen[t] || 0) + 1; }); }); });
    var changed = false;
    var out = words.map(function (w) {
      if (w.length < 4 || /[^a-z\u00c0-\u024f'-]/.test(w)) return w;
      var toks = Object.keys(seen);
      if (toks.some(function (t) { return t === w || t.indexOf(w) === 0 || w.indexOf(t) === 0; })) return w;
      var best = '', bc = 0;
      toks.forEach(function (t) { if (t.length >= w.length - 1 && lev(w, t) <= 2 && seen[t] > bc) { best = t; bc = seen[t]; } });
      if (best) { changed = true; return best; } return w;
    });
    return changed ? out.join(' ') : '';
  }
  var HL = { highlight_fields: 'name,title,type_line,oracle_text,flavor_text', highlight_affix_num_tokens: 0, snippet_threshold: 0 };
  var SEARCH_TIMEOUT = 8000;   // a hung request gives up so pages fall back / show the "try again" message instead of loading forever
  function multiSearch(searches) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, SEARCH_TIMEOUT) : 0;
    function done(x) { clearTimeout(timer); return x; }
    return fetch(CFG.host + '/multi_search?use_cache=true&cache_ttl=120', {   // short server cache: repeat browse pages answer instantly
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-TYPESENSE-API-KEY': CFG.key },
      body: JSON.stringify({ searches: searches.map(function (s) { s.collection = COLL; return s; }) }),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
      .then(function (j) { done(); return j.results; }, function (e) { done(); throw e; });
  }
  function searchUrl(params) {
    var u = new URL(CFG.searchUrl || '/search', location.origin);
    Object.keys(params).forEach(function (k) {
      var v = params[k]; if (v == null || v === '' || (Array.isArray(v) && !v.length)) return;
      if (Array.isArray(v)) v.forEach(function (x) { u.searchParams.append(k, x); }); else u.searchParams.set(k, v);
    });
    return u.pathname + u.search;
  }
  function isSingle(d) { return /single|graded/i.test(d.kind || '') || d.category === 'Singles'; }
  // singles: lowest in-stock variant price ("From" only when in-stock prices differ); otherwise lowest overall
  function singlePrice(d) {
    var all = variants(d), pool = all.filter(function (v) { return v.q > 0; });
    if (!pool.length) pool = all;
    var ps = pool.map(function (v) { return Number(v.p); }).filter(function (x) { return !isNaN(x); });
    if (!ps.length) return { low: d.price, from: false };
    var low = Math.min.apply(null, ps);
    return { low: low, from: ps.some(function (x) { return Math.abs(x - low) > 0.001; }) };
  }
  function stockLine(d) {
    if (!d.in_stock) return '';
    if (isSingle(d)) return 'In stock';
    var c = (d.condition_in_stock || []).slice().sort(function (a, b) { return COND_ORDER.indexOf(a) - COND_ORDER.indexOf(b); });
    if (c.length) return c.map(function (x) { return COND_SHORT[x] || x; }).join(' · ') + ' in stock';
    // (QA 10/26: no 'Only N left' text anywhere in search, per Ryan; was: total_qty <= 3 -> 'Only N left')
    return 'In stock';
  }
  function priceHtml(d, cls) {
    if (isSingle(d)) {
      var sp = singlePrice(d);
      return '<div class="' + cls + '">' + (sp.from ? 'From ' : '') + money(sp.low) + '</div>';
    }
    var from = d.price_max && d.price_max > d.price + 0.001 && (!d.in_stock || variants(d).filter(function (v) { return v.q > 0; }).length > 1);
    var h = '';
    if (d.compare_at && d.compare_at > d.price) h += '<span class="visually-hidden">Regular price</span><span class="grid-product__price--original">' + money(d.compare_at) + '</span> <span class="visually-hidden">Sale price</span>';
    h += (from ? 'from ' : '') + money(d.price);
    return '<div class="' + cls + (d.compare_at > d.price ? ' grid-product__price--sale' : '') + '">' + h + '</div>';
  }

  /* ---------------- header instant results ---------------- */
  function previewHtml(d) {
    var single = isSingle(d), rows = [];
    function row(k, v) { if (v && (!Array.isArray(v) || v.length)) rows.push('<dt>' + k + '</dt><dd>' + esc(Array.isArray(v) ? v.join(', ') : v) + '</dd>'); }
    if (single) {
      row('Set', d.set); row('Rarity', d.rarity); row('Type', d.type_line || d.card_type); row('Color', d.color); row('Finish', d.finish); row('Artist', d.artist);
      var vs = variants(d).filter(function (v) { return v.q > 0; }).sort(function (a, b) { return COND_ORDER.indexOf(a.t) - COND_ORDER.indexOf(b.t); });
      if (vs.length) rows.push('<dt>In stock</dt><dd>' + vs.map(function (v) { return esc(v.t) + ' ' + money(v.p); }).join('<br>') + '</dd>');
    } else {
      row('Type', d.category); row('Brand', d.brand); row('Game', d.game); if (d.set && d.set !== d.game) row('Set', d.set);
    }
    var price = d.in_stock ? (single ? (function (sp) { return (sp.from ? 'from ' : '') + money(sp.low); })(singlePrice(d)) : money(d.price)) : 'Sold out';
    return '<a class="bb-pv__img" href="' + esc(d.url) + '" tabindex="-1">' + (d.image ? '<img src="' + esc(img(d.image, 480)) + '" alt="">' : '') + '</a>' +
      '<div class="bb-pv__body"><a class="bb-pv__title" href="' + esc(d.url) + '" tabindex="-1">' + esc(d.title) + '</a>' +
      '<div class="bb-pv__price' + (d.in_stock ? '' : ' is-so') + '">' + price + '</div>' +
      (rows.length ? '<dl class="bb-pv__dl">' + rows.join('') + '</dl>' : '') +
      '<a class="bb-pv__more text-link" href="' + esc(d.url) + '" tabindex="-1">See details</a></div>';
  }
  function initPredictive() {
    var els = document.querySelectorAll('predictive-search');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.context === 'search-page' && document.getElementById('BbSearch')) return; // page box drives the page itself
      var input = el.querySelector('input[type="search"]');
      var box = el.querySelector('#predictive-search, .search__results');
      if (!input || !box) return;
      var seq = 0, last = null, active = -1;
      el.classList.add('bb-ps');
      // the theme calls getSearchResults(term) after its own debounce; ours runs sooner, so skip repeats
      el.getSearchResults = function (term) { if (term !== last) run(term); };
      var hits = [], pv = null, pvTimer = 0, PV = window.matchMedia ? window.matchMedia('(hover: hover) and (min-width: 769px)') : { matches: false };
      // desktop: hovering (or arrowing to) a result shows a details pane beside the dropdown
      function hidePv() { clearTimeout(pvTimer); if (pv) pv.hidden = true; }
      function showPv(i, anchor) {
        clearTimeout(pvTimer);
        var d = hits[i] && hits[i].document; if (!d || !PV.matches) return;
        if (!pv) {
          pv = document.createElement('div'); pv.className = 'bb-pv'; pv.hidden = true; document.body.appendChild(pv);
          pv.addEventListener('mouseenter', function () { clearTimeout(pvTimer); });
          pv.addEventListener('mouseleave', function () { pvTimer = setTimeout(hidePv, 150); });
        }
        if (pv.dataset.id !== d.id) { pv.innerHTML = previewHtml(d); pv.dataset.id = d.id; }
        pv.hidden = false;
        var b = box.getBoundingClientRect(), a = anchor.getBoundingClientRect(), w = pv.offsetWidth, h = pv.offsetHeight, vw = document.documentElement.clientWidth;
        var left = vw - b.right >= w + 12 ? b.right + 8 : (b.left >= w + 12 ? b.left - w - 8 : b.right - w - 8);
        var top = Math.max(8, Math.min(a.top - 10, window.innerHeight - h - 8));
        pv.style.left = Math.round(left) + 'px'; pv.style.top = Math.round(top) + 'px';
        // the picture arrives after we measured: re-place the pane so it doesn't run off the bottom of the screen
        var im = pv.querySelector('img');
        if (im && !im.complete) im.addEventListener('load', function () { if (!pv.hidden && pv.dataset.id === d.id) showPv(i, anchor); }, { once: true });
      }
      box.addEventListener('mouseover', function (e) { var a = e.target.closest('.bb-ac__item'); if (a) showPv(+a.dataset.i, a); });
      box.addEventListener('mouseleave', function () { pvTimer = setTimeout(hidePv, 150); });
      window.addEventListener('scroll', hidePv, { passive: true });
      function close() { hidePv(); box.style.display = 'none'; box.innerHTML = ''; last = null; active = -1; input.setAttribute('aria-expanded', 'false'); }
      function run(term) {
        term = term.trim(); last = term;
        if (!term) { close(); return; }
        var my = ++seq;
        var p = baseParams(term, 'ac');
        p.sort_by = rankSort(term, 'ac'); p.per_page = 6; p.include_fields = FIELDS + ',rarity,card_type,type_line,color,artist,finish,brand,set_code'; p.facet_by = 'category'; p.max_facet_values = 4;
        Object.assign(p, HL);
        multiSearch([p]).then(function (res) {
          if (my !== seq) return;
          var fix = corrected(term, res[0].hits);
          if (!fix) { render(term, res[0]); return; }
          var p2 = Object.assign({}, p, baseParams(fix, 'ac')); p2.sort_by = rankSort(fix, 'ac');
          return multiSearch([p2]).then(function (r2) { if (my === seq) render(term, r2[0].found ? r2[0] : res[0]); });
        }).catch(function () { /* stay quiet; the form still submits to the results page */ });
      }
      function render(term, r) {
        hits = (r && r.hits) || []; hidePv();
        var all = searchUrl({ q: term });
        var h = '<div class="bb-ac" role="listbox" id="bb-ac-' + (el.dataset.context || 'x') + '">';
        if (!hits.length) {
          h += '<div class="bb-ac__empty">No matches for “' + esc(term) + '”</div>';
        } else {
          var cats = ((r.facet_counts || [])[0] || {}).counts || [];
          if (cats.length > 1) {
            h += '<div class="bb-ac__cats">' + cats.map(function (c) {
              return '<a class="bb-ac__cat" href="' + esc(searchUrl({ q: term, category: [c.value] })) + '">' + esc(c.value) + ' <span>' + c.count + '</span></a>';
            }).join('') + '</div>';
          }
          h += '<ul class="bb-ac__list">' + hits.map(function (x, i) {
            var d = x.document;
            var sub = [d.set || d.category, stockLine(d)].filter(Boolean).join(' — ');
            return '<li><a class="bb-ac__item' + (d.in_stock ? '' : ' is-sold-out') + '" role="option" href="' + esc(d.url) + '" data-i="' + i + '">' +
              '<span class="bb-ac__img">' + (d.image ? '<img src="' + esc(img(d.image, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="bb-ac__txt"><span class="bb-ac__title">' + esc(d.title) + '</span><span class="bb-ac__sub">' + esc(sub) + '</span></span>' +
              '<span class="bb-ac__price">' + (d.in_stock ? (isSingle(d) ? (function (sp) { return (sp.from ? 'From ' : '') + money(sp.low); })(singlePrice(d)) : money(d.price)) : '<span class="bb-ac__so">Sold out</span>') + '</span></a></li>';
          }).join('') + '</ul>';
          h += '<a class="bb-ac__all" href="' + esc(all) + '">See all ' + r.found.toLocaleString() + ' results</a>';
        }
        h += '</div>';
        box.innerHTML = h; box.style.display = 'block'; active = -1;
        input.setAttribute('aria-expanded', 'true');
        el.classList.add('is-active');
      }
      input.addEventListener('input', debounce(function () { run(input.value); }, 120));
      input.addEventListener('keydown', function (e) {
        var items = box.querySelectorAll('.bb-ac__item, .bb-ac__all');
        if (!items.length) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          active = e.key === 'ArrowDown' ? Math.min(active + 1, items.length - 1) : Math.max(active - 1, -1);
          Array.prototype.forEach.call(items, function (a, i) { a.classList.toggle('is-active', i === active); });
          if (active > -1) { items[active].scrollIntoView({ block: 'nearest' }); if (items[active].dataset.i != null) showPv(+items[active].dataset.i, items[active]); else hidePv(); } else hidePv();
        } else if (e.key === 'Enter' && active > -1) {
          e.preventDefault(); location.href = items[active].getAttribute('href');
        }
      });
      // send the plain query (drop the theme's hidden type/prefix params)
      var form = input.form;
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = input.value.trim(); location.href = searchUrl({ q: v });
      });
    });
  }

  /* ---------------- results page ---------------- */
  var RARITY_ORDER = ['Common', 'Uncommon', 'Rare', 'Mythic', 'Mythic Rare', 'Special', 'Bonus', 'Land', 'Token', 'Promo'];
  var COLOR_ORDER = ['White', 'Blue', 'Black', 'Red', 'Green', 'Multicolor', 'Colorless', 'Artifact', 'Land'];
  // bb-search role v1
  var ROLE_ORDER = ['Ramp', 'Card Draw', 'Removal', 'Board Wipe', 'Counterspell', 'Tutor', 'Protection', 'Win Condition', 'Game Changer'];
  var DISCOUNT_ORDER = ['Up to 10%', '10 – 20%', '20 – 40%', '40% and above'];
  // parity: the filters the old (XCloud) filter bar had; shown whenever they have any value
  var ALL_FACETS = {
    set: { key: 'set', field: 'vendor', label: 'Set', searchable: true, parity: true, alpha: true },
    ptype: { key: 'ptype', field: 'product_type', label: 'Product type', parity: true, alpha: true },
    discount: { key: 'discount', field: 'discount', label: 'Discount', order: DISCOUNT_ORDER, parity: true },
    category: { key: 'category', field: 'category', label: 'Category' },
    game: { key: 'game', field: 'game', label: 'Game' },
    rarity: { key: 'rarity', field: 'rarity', label: 'Rarity', order: RARITY_ORDER },
    color: { key: 'color', field: 'color', label: 'Color', order: COLOR_ORDER },
    role: { key: 'role', field: 'role', label: 'Role', order: ROLE_ORDER },
    card_type: { key: 'card_type', field: 'card_types', label: 'Card type', searchable: true },   // card_types: every word of the type line (Creature, Vampire, Legendary...)
    brand: { key: 'brand', field: 'brand', label: 'Brand' },
    condition: { key: 'condition', field: 'condition', label: 'Condition', order: COND_ORDER, parity: true },
    finish: { key: 'finish', field: 'finish', label: 'Finish' },
    tags: { key: 'tags', field: 'tags', label: 'Tags', searchable: true, lazy: true, parity: true }   // counted only when its panel is open or in use
  };
  // store-internal tags that mean nothing to shoppers
  // Typesense matches filter values ignoring case and punctuation ("Ultra PRO" = "Ultra Pro", "C" = "C++"), so show such
  // look-alike values as one option with the combined count; otherwise the count beside an option wouldn't match its results
  function alikeKey(v) { return String(v).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-\/]/g, ' ').replace(/[^\p{L}\p{N}\s]/gu, '').replace(/\s+/g, ' ').trim(); }
  function mergeAlike(counts, sel) {
    var by = {}, out = [];
    counts.forEach(function (c) {
      var k = alikeKey(c.value) || c.value, m = by[k];
      if (!m) { m = by[k] = { value: c.value, count: 0 }; out.push(m); }
      else if (sel && sel.indexOf(c.value) > -1) m.value = c.value;
      m.count += c.count;
    });
    return out;
  }
  function noiseTag(t) { return t.length < 2 || /^Role: /.test(t) || /_/.test(t) || /^[a-z0-9]+(-[a-z0-9]+)+$/.test(t); }
  // which filters each kind of page shows: every page keeps the old filter bar's set (Set, Product type, Discount,
  // Condition, Tags; hidden only when empty), plus our extra filters (hidden when there's nothing to choose between)
  var PARITY = ['set', 'ptype', 'discount', 'condition'];
  function presetFor(handle) { return PARITY.concat(presetExtra(handle), ['tags']); }
  function presetExtra(handle) {
    var h = handle || '';
    if (!h) return ['category', 'game', 'role', 'finish'];                                              // site search
    if (/magic|mtg/.test(h) && /single/.test(h)) return ['rarity', 'color', 'card_type', 'role', 'finish'];
    if (/single|graded/.test(h)) return ['rarity', 'card_type', 'finish'];
    if (/board-game|suppl|accessor|lego|warhammer|miniature|dungeons|event/.test(h)) return ['game'];
    return ['category', 'game', 'rarity', 'finish'];
  }
  var FACETS = [];
  var IS_COLL = false, DEFAULT_SORT = 'relevance';
  var BROWSE_SORT = 'best';   // live store default
  function defaultSort(q) { return IS_COLL && !q ? BROWSE_SORT : 'relevance'; }
  function readState() {
    var sp = new URLSearchParams(location.search), q = sp.get('q') || '', srt = sp.get('sort');
    if (!SORTS[srt] || (srt === 'relevance' && IS_COLL && !q) || (srt === 'featured' && !IS_COLL)) srt = defaultSort(q);
    var st = { q: q, page: Math.max(1, parseInt(sp.get('page') || '1', 10) || 1), sort: srt, instock: sp.get('instock') === '1', min: sp.get('min') || '', max: sp.get('max') || '', f: {} };
    FACETS.forEach(function (f) { st.f[f.key] = sp.getAll(f.key); });
    return st;
  }
  function stateUrl(st) {
    var o = { q: st.q, sort: st.sort !== defaultSort(st.q) ? st.sort : '', instock: st.instock ? '1' : '', min: st.min, max: st.max, page: st.page > 1 ? st.page : '' };
    FACETS.forEach(function (f) { o[f.key] = st.f[f.key]; });
    if (!IS_COLL) return searchUrl(o);
    var u = new URL(location.pathname, location.origin);
    Object.keys(o).forEach(function (k) { var v = o[k]; if (v == null || v === '' || (Array.isArray(v) && !v.length)) return; (Array.isArray(v) ? v : [v]).forEach(function (x) { u.searchParams.append(k, x); }); });
    return u.pathname + u.search;
  }
  function filterFor(st, skipKey, root) {
    var parts = [];
    if (root.dataset.collection) parts.push('collections:=[`' + bt(root.dataset.collection) + '`]');
    if (st.instock) parts.push('in_stock:=true');
    FACETS.forEach(function (f) {
      if (f.key === skipKey) return;
      var v = st.f[f.key]; if (!v.length) return;
      var field = (f.key === 'condition' && st.instock) ? 'condition_in_stock' : f.field;
      parts.push(field + ':=[' + v.map(function (x) { return '`' + bt(x) + '`'; }).join(',') + ']');
    });
    var mn = parseFloat(st.min), mx = parseFloat(st.max);
    if (!isNaN(mn) && !isNaN(mx)) parts.push('price:[' + mn + '..' + mx + ']');
    else if (!isNaN(mn)) parts.push('price:>=' + mn);
    else if (!isNaN(mx)) parts.push('price:<=' + mx);
    return parts.join(' && ');
  }

  function initPage() {
    var root = document.getElementById('BbSearch');
    if (!root) return;
    IS_COLL = root.dataset.mode === 'collection';
    if (SORTS[root.dataset.defaultSort]) BROWSE_SORT = root.dataset.defaultSort;
    FEATURED = root.dataset.featured === 'manual' ? 'manual' : (SHOPIFY_SORT[root.dataset.featured] || 'best');
    FACETS = presetFor(IS_COLL ? (root.dataset.preset || root.dataset.collection || 'all-products') : '').map(function (k) { return ALL_FACETS[k]; });
    var st = readState();
    var ssr = IS_COLL ? { grid: root.querySelector('.bb-s__grid').innerHTML, pag: root.querySelector('.bb-s__pagination').innerHTML } : null;
    var ssrCount = parseInt(root.dataset.count || '0', 10);
    var openGroups = {}; var fq = {}; var showAll = {}; var last = null;
    var BAR = window.matchMedia ? window.matchMedia('(min-width: 769px)') : { matches: true };
    function openAttr(key, dflt) { var o = openGroups[key]; if (o == null) o = BAR.matches ? false : dflt; return o ? ' open' : ''; }
    function pill(key, label, n, body, cls) {
      return '<details class="bb-s__group' + (cls ? ' ' + cls : '') + '" data-key="' + key + '"' + body.open + '><summary class="bb-s__group-title">' + label +
        (n ? ' <span class="bb-s__group-n">' + n + '</span>' : '') + '</summary><div class="bb-s__group-body">' + body.html + '</div></details>';
    }
    var els = {
      input: root.querySelector('.bb-s__input'), form: root.querySelector('.bb-s__form'),
      count: root.querySelector('.bb-s__count'), sort: root.querySelector('.bb-s__sort'),
      side: root.querySelector('.bb-s__filters'), chips: root.querySelector('.bb-s__chips'),
      grid: root.querySelector('.bb-s__grid'), pag: root.querySelector('.bb-s__pagination'),
      toggle: root.querySelector('.bb-s__filter-toggle'), drawerClose: root.querySelector('.bb-s__drawer-close'),
      instockCount: null
    };
    // search page: Featured would equal Most relevant, so it's only offered on collections
    function sortKeys() { return Object.keys(SORTS).filter(function (k) { return !(IS_COLL && k === 'relevance' && !st.q) && !(!IS_COLL && k === 'featured'); }); }
    function sortOptions() {
      var keys = sortKeys();
      var h = keys.map(function (k) { return '<option value="' + k + '">' + SORTS[k].label + '</option>'; }).join('');
      if (els.sort.innerHTML !== h) els.sort.innerHTML = h;
    }
    var seq = 0, fixedFor = {}, cardCache = {};
    // collection pages: if search is unreachable or the index doesn't know this collection, keep the theme's own grid
    function fallback() {
      root.classList.remove('is-loading', 'bb-c-pending'); root.classList.add('is-fallback');
      els.grid.innerHTML = ssr.grid; els.pag.innerHTML = ssr.pag; els.count.textContent = '';
    }

    function go(push) {
      if (push !== false) history.pushState(null, '', stateUrl(st));
      load();
    }
    function facetSearch(f, field) {
      var p = baseParams(fixedFor[st.q] || st.q);
      p.filter_by = filterFor(st, f.key, root); p.per_page = 0; p.max_facet_values = 2000; p.facet_by = field;
      if (fq[f.key]) p.facet_query = field + ':' + bt(fq[f.key]);
      return p;
    }
    // fetch just one lazy facet (Tags) when its panel opens, without reloading results
    function loadFacet(key) {
      var f = ALL_FACETS[key]; if (!last || !f) return;
      var my = seq;
      multiSearch([facetSearch(f, f.field)]).then(function (res) {
        if (my !== seq || !last) return;
        (res[0].facet_counts || []).forEach(function (fc) { last.facetMap[fc.field_name] = fc; });
        last.facetMap['__' + key] = 1; renderFilters(last.facetMap, last.inStockN, last.r);
      }).catch(function () { });
    }
    function load() {
      var my = ++seq;
      sortOptions(); els.input.value = st.q; els.sort.value = st.sort;
      if (!IS_COLL) document.title = (st.q ? 'Search: ' + st.q : 'Search') + ' – ' + (CFG.shopName || '');
      root.classList.add('is-loading');
      var main = baseParams(st.q);
      main.sort_by = sortBy(st.sort, st.q);
      main.filter_by = filterFor(st, null, root);
      main.per_page = PER_PAGE; main.page = st.page; main.include_fields = FIELDS; Object.assign(main, HL);
      var useQ = fixedFor[st.q] || st.q;
      if (useQ !== st.q) { Object.assign(main, baseParams(useQ)); main.sort_by = sortBy(st.sort, useQ); }
      function fieldOf(f) { return f.key === 'condition' && st.instock ? 'condition_in_stock' : f.field; }
      // lazy facets (Tags) are counted only while their panel is open or being searched; a closed pill just shows its selection count
      function wanted(f) { return !f.lazy || openGroups[f.key] === true || !!fq[f.key]; }
      main.facet_by = FACETS.filter(function (f) { return !f.lazy && !fq[f.key] && !st.f[f.key].length; }).map(fieldOf).concat(['price(all:[0, 100000000])', 'in_stock']).join(',');   // range facet = min/max stats without listing every price
      main.max_facet_values = 2000;
      var searches = [main];
      // disjunctive counts: a facet with a selection is counted without its own filter; searched/lazy facets get their own query
      var extra = [];
      FACETS.forEach(function (f) {
        if (!wanted(f)) return;
        if (!st.f[f.key].length && !fq[f.key] && !f.lazy) return;
        searches.push(facetSearch(f, fieldOf(f))); extra.push(f.key);
      });
      // in-stock count for the toggle label comes from the main query's in_stock facet (no extra search)
      multiSearch(searches).then(function (res) {
        if (my !== seq) return;
        var r = res[0]; if (r.error) throw new Error(r.error);
        if (st.q && fixedFor[st.q] == null && st.page === 1) {
          var fix = corrected(st.q, r.hits); fixedFor[st.q] = fix || st.q;
          if (fix) { load(); return; }   // re-run with the corrected words (same filters, counts)
        }
        if (IS_COLL && !r.found && !st.q && !activeCount() && ssrCount > 0) { fallback(); return; }
        var facetMap = {};
        (r.facet_counts || []).forEach(function (fc) { facetMap[fc.field_name] = fc; });
        var inStockN = r.found;
        if (!st.instock) { inStockN = 0; ((facetMap.in_stock && facetMap.in_stock.counts) || []).forEach(function (c) { if (c.value === 'true') inStockN = c.count; }); }
        extra.forEach(function (k, i) {
          var rr = res[i + 1];
          if (k === '__instock') { inStockN = rr.found; return; }
          (rr.facet_counts || []).forEach(function (fc) { facetMap[fc.field_name] = fc; });
        });
        FACETS.forEach(function (f) { if (f.lazy && wanted(f)) facetMap['__' + f.key] = 1; });
        last = { r: r, facetMap: facetMap, inStockN: inStockN };
        renderAll(r, facetMap, inStockN);
      }).catch(function (e) {
        if (my !== seq) return;
        if (IS_COLL) { fallback(); return; }
        root.classList.remove('is-loading');
        els.grid.innerHTML = '<p class="bb-s__empty">Search is having trouble right now. Please try again in a moment.</p>';
      });
    }

    function renderAll(r, facetMap, inStockN) {
      root.classList.remove('is-loading', 'bb-c-pending', 'is-fallback');
      var noun = IS_COLL && !st.q ? (r.found === 1 ? ' product' : ' products') : (r.found === 1 ? ' result' : ' results');
      var fx = st.q && fixedFor[st.q] && fixedFor[st.q] !== st.q.toLowerCase() ? fixedFor[st.q] : '';
      els.count.innerHTML = esc(r.found.toLocaleString() + noun) + (fx ? ' for “' + esc(fx) + '”' : '');
      renderFilters(facetMap, inStockN, r);
      renderChips();
      renderGrid(r);
      renderPagination(r);
    }

    function groupHtml(f, fc, facetMap) {
      var counts = ((fc && fc.counts) || []).slice();
      var sel = st.f[f.key], q = fq[f.key] || '';
      if (f.lazy && !facetMap['__' + f.key]) return pill(f.key, esc(f.label), sel.length, { open: openAttr(f.key, false), html: '<p class="bb-s__loading">Loading…</p>' });
      if (f.key === 'tags') {
        // hide only store-internal tags (e.g. Printing_Foil, new-arrival)
        counts = counts.filter(function (c) { return sel.indexOf(c.value) > -1 || !noiseTag(c.value); });
      }
      counts = mergeAlike(counts, sel);
      // keep selected values visible even if they have 0 matches now
      sel.forEach(function (v) { if (!counts.some(function (c) { return c.value === v; })) counts.push({ value: v, count: 0 }); });
      if (f.order) counts.sort(function (a, b) { var ia = f.order.indexOf(a.value), ib = f.order.indexOf(b.value); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
      else if (f.alpha) counts.sort(function (a, b) { return a.value.localeCompare(b.value, undefined, { numeric: true, sensitivity: 'base' }); });
      else if (!q) counts.sort(function (a, b) { return b.count - a.count || a.value.localeCompare(b.value); });
      if (!counts.length && !(f.searchable && q)) return '';
      if (counts.length < 2 && !f.parity && !sel.length && !(f.searchable && q)) return '';   // nothing to choose between
      var open = openAttr(f.key, sel.length > 0 || (IS_COLL ? FACETS.indexOf(f) < 2 : (f.key === 'category' || f.key === 'game')));
      var limit = showAll[f.key] ? 1e9 : (f.key === 'role' ? 12 : 8);
      var h = '';
      if (f.searchable && (counts.length > 8 || q)) h += '<input type="search" class="bb-s__facet-search" data-fq="' + f.key + '" placeholder="Search options" value="' + esc(q) + '" aria-label="Search ' + esc(f.label) + ' options">';
      h += '<ul class="bb-s__opts">' + counts.slice(0, limit).map(function (c) {
        var on = sel.indexOf(c.value) > -1;
        return '<li><label class="bb-s__opt' + (c.count === 0 && !on ? ' is-empty' : '') + '"><input type="checkbox" data-facet="' + f.key + '" value="' + esc(c.value) + '"' + (on ? ' checked' : '') + '>' +
          '<span class="bb-s__opt-label">' + esc(c.value) + '</span><span class="bb-s__opt-n">' + c.count.toLocaleString() + '</span></label></li>';
      }).join('') + '</ul>';
      if (counts.length > limit) h += '<button type="button" class="bb-s__more text-link" data-more="' + f.key + '">' + (counts.length >= 2000 ? 'Show more' : 'Show all ' + counts.length) + '</button>';
      else if (showAll[f.key] && counts.length > 8) h += '<button type="button" class="bb-s__more text-link" data-less="' + f.key + '">Show fewer</button>';
      return pill(f.key, esc(f.label), sel.length, { open: open, html: h });
    }

    function renderFilters(facetMap, inStockN, r) {
      var ps = (facetMap.price && facetMap.price.stats) || {};
      var h = pill('price', 'Price', st.min || st.max ? 1 : 0, { open: openAttr('price', !!(st.min || st.max)), html: '<form class="bb-s__price">' +
        '<label><span class="visually-hidden">Min price</span><input type="number" inputmode="decimal" min="0" step="0.01" name="min" placeholder="$' + Math.floor(ps.min || 0) + '" value="' + esc(st.min) + '"></label><span class="bb-s__dash">to</span>' +
        '<label><span class="visually-hidden">Max price</span><input type="number" inputmode="decimal" min="0" step="0.01" name="max" placeholder="$' + Math.ceil(ps.max || 0) + '" value="' + esc(st.max) + '"></label>' +
        '<button type="submit" class="btn btn--small">Go</button></form>' });
      h += pill('availability', 'Availability', st.instock ? 1 : 0, { open: openAttr('availability', true), html: '<ul class="bb-s__opts"><li><label class="bb-s__opt"><input type="checkbox" class="bb-s__instock-input"' + (st.instock ? ' checked' : '') + '>' +
        '<span class="bb-s__opt-label">In stock</span><span class="bb-s__opt-n">' + (inStockN != null ? inStockN.toLocaleString() : '') + '</span></label></li></ul>' });
      FACETS.forEach(function (f) {
        var field = f.key === 'condition' && st.instock ? 'condition_in_stock' : f.field;
        h += groupHtml(f, facetMap[field], facetMap);
      });
      if (IS_COLL) h += pill('within', 'Search', st.q ? 1 : 0, { open: openAttr('within', false), html: '<form class="bb-s__within" role="search"><input type="search" name="q" class="bb-s__within-input" value="' + esc(st.q) + '" placeholder="' + esc(els.input.placeholder || 'Search') + '" aria-label="' + esc(els.input.placeholder || 'Search') + '" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"><button type="submit" class="btn btn--small">Go</button></form>' });
      var keys = sortKeys();
      h += pill('sort', 'Sort by: ' + esc(SORTS[st.sort] ? SORTS[st.sort].label : ''), 0, { open: openAttr('sort', false), html: '<ul class="bb-s__opts bb-s__sorts">' + keys.map(function (k) {
        return '<li><button type="button" class="bb-s__sort-opt' + (k === st.sort ? ' is-on' : '') + '" data-sort="' + k + '"' + (k === st.sort ? ' aria-current="true"' : '') + '>' + esc(SORTS[k].label) + '</button></li>'; }).join('') + '</ul>' }, 'bb-s__group--sort');
      // keep focus in the set search box while typing
      var focused = document.activeElement && document.activeElement.classList.contains('bb-s__facet-search') && els.side.contains(document.activeElement);
      var caret = focused ? document.activeElement.selectionStart : 0, fkey = focused ? document.activeElement.dataset.fq : '';
      els.side.innerHTML = h;
      if (focused) { var fs = els.side.querySelector('.bb-s__facet-search[data-fq="' + fkey + '"]'); if (fs) { fs.focus(); fs.setSelectionRange(caret, caret); } }
      var n = activeCount();
      els.toggle.querySelector('.bb-s__filter-n').textContent = n ? n : '';
    }
    function activeCount() { var n = st.instock ? 1 : 0; FACETS.forEach(function (f) { n += st.f[f.key].length; }); if (st.min || st.max) n++; return n; }

    function renderChips() {
      var chips = [];
      if (IS_COLL && st.q) chips.push(['q', '', '“' + st.q + '”']);
      if (st.instock) chips.push(['instock', '', 'In stock']);
      FACETS.forEach(function (f) { st.f[f.key].forEach(function (v) { chips.push([f.key, v, v]); }); });
      if (st.min || st.max) chips.push(['price', '', (st.min ? money(st.min) : '$0') + ' – ' + (st.max ? money(st.max) : 'any')]);
      if (!chips.length) { els.chips.innerHTML = ''; els.chips.hidden = true; return; }
      els.chips.hidden = false;
      els.chips.innerHTML = chips.map(function (c) {
        return '<button type="button" class="bb-s__chip" data-k="' + c[0] + '" data-v="' + esc(c[1]) + '">' + esc(c[2]) + '<span aria-hidden="true">×</span><span class="visually-hidden">Remove filter</span></button>';
      }).join('') + (chips.length > 1 ? '<button type="button" class="bb-s__clear text-link">Clear all</button>' : '');
    }

    // fallback only (theme card fetch failed): same structure as the theme's product-grid-item, no extras
    function card(d) {
      return '<div class="grid__item grid-product small--one-half medium-up--one-quarter bb-s__item' + (d.in_stock ? '' : ' is-sold-out') + '">' +
        '<div class="grid-product__content">' +
        (d.in_stock ? (d.compare_at > d.price ? '<div class="grid-product__tag grid-product__tag--sale">Sale</div>' : '') : '<div class="grid-product__tag grid-product__tag--sold-out">Sold out</div>') +
        '<a href="' + esc(d.url) + '" class="grid-product__link"><div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--square">' +
        (d.image ? '<img class="grid__image-contain" loading="lazy" src="' + esc(img(d.image, 360)) + '" srcset="' + esc(img(d.image, 360)) + ' 360w, ' + esc(img(d.image, 540)) + ' 540w, ' + esc(img(d.image, 720)) + ' 720w" sizes="(min-width: 769px) 20vw, 50vw" alt="' + esc(d.title) + '">' : '') +
        '</div></div><div class="grid-product__meta"><div class="grid-product__title grid-product__title--body">' + esc(d.title) + '</div>' +
        priceHtml(d, 'grid-product__price').replace('>From ', '>from ') + '</div></a></div></div>';
    }

    function renderGrid(r) {
      var hits = r.hits || [];
      var hasF = activeCount() > 0;
      root.classList.toggle('is-noresults', !hits.length && !hasF);
      if (!hits.length) {
        els.grid.innerHTML = '<div class="bb-s__empty"><p>' + (st.q ? 'No results for “' + esc(st.q) + '”' + (hasF ? ' with these filters.' : '.') : 'No products match these filters.') + '</p>' +
          (hasF ? '<button type="button" class="btn bb-s__clear">Clear filters</button>' : '<p>Check the spelling, or try a card name, set code (e.g. AFR-344) or fewer words.</p>') + '</div>';
        return;
      }
      themeCards(hits.map(function (h) { return h.document; }));
    }
    // Product cards come from the theme's own snippet (templates/search.bb-cards.liquid), so they match the rest of the store.
    var cardSeq = 0;
    function themeCards(docs) {
      var my = ++cardSeq, need = docs.filter(function (d) { return d.handle && !cardCache[d.handle]; }).map(function (d) { return d.handle; });
      function paint() {
        if (my !== cardSeq) return;
        els.grid.innerHTML = docs.map(function (d) { return cardCache[d.handle] || card(d); }).join('');
        root.classList.remove('is-cards-loading');
        if (window.theme && typeof theme.initQuickShop === 'function') { try { theme.initQuickShop(); } catch (e) { } }
        if (window.AOS) { try { AOS.refreshHard(); } catch (e) { } }
      }
      if (!need.length) { paint(); return; }
      root.classList.add('is-cards-loading');
      var chunks = []; for (var i = 0; i < need.length; i += 12) chunks.push(need.slice(i, i + 12));
      var prev = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') ? '&preview_theme_id=' + Shopify.theme.id : '';
      var coll = IS_COLL && root.dataset.collection ? 'c:' + root.dataset.collection + ' ' : '';
      var timer = new Promise(function (res) { setTimeout(res, 5000); });
      Promise.race([Promise.all(chunks.map(function (c) {
        return fetch((CFG.searchUrl || '/search') + '?view=bb-cards&type=product&q=' + encodeURIComponent(coll + c.join(' ')) + prev, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            Array.prototype.forEach.call(tmp.querySelectorAll('[data-bb-card]'), function (el) { cardCache[el.dataset.bbCard] = el.innerHTML; });
          }).catch(function () { });
      })), timer]).then(paint);
    }

    function renderPagination(r) {
      var pages = Math.min(Math.ceil(r.found / PER_PAGE), Math.floor(25000 / PER_PAGE));
      if (pages <= 1) { els.pag.innerHTML = ''; return; }
      var p = st.page, h = '';
      function link(n, label, cls) { return '<span class="' + (cls || 'page') + '"><a href="' + esc(stateUrl(Object.assign({}, st, { page: n }))) + '" data-page="' + n + '">' + label + '</a></span>'; }
      if (p > 1) h += link(p - 1, '<span aria-hidden="true">&larr;</span><span class="icon__fallback-text">Previous</span>', 'prev');
      var nums = [1, p - 1, p, p + 1, pages].filter(function (n, i, a) { return n >= 1 && n <= pages && a.indexOf(n) === i; }).sort(function (a, b) { return a - b; });
      nums.forEach(function (n, i) {
        if (i && n - nums[i - 1] > 1) h += '<span class="deco">…</span>';
        h += n === p ? '<span class="page current">' + n + '</span>' : link(n, n);
      });
      if (p < pages) h += link(p + 1, '<span aria-hidden="true">&rarr;</span><span class="icon__fallback-text">Next</span>', 'next');
      els.pag.innerHTML = '<div class="pagination">' + h + '</div>';
    }

    /* events */
    els.form.addEventListener('submit', function (e) {
      e.preventDefault(); var nq = els.input.value.trim();
      if (st.sort === defaultSort(st.q)) st.sort = defaultSort(nq);   // typed a search: best match first; cleared it: back to the page default
      else if (st.sort === 'relevance' && !nq && IS_COLL) st.sort = defaultSort('');
      st.q = nq; st.page = 1; go();
    });
    els.sort.addEventListener('change', function () { st.sort = els.sort.value; st.page = 1; go(); });
    els.side.addEventListener('change', function (e) {
      var t = e.target;
      if (t.classList.contains('bb-s__instock-input')) { st.instock = t.checked; st.page = 1; go(); return; }
      if (t.dataset.facet) {
        var arr = st.f[t.dataset.facet], i = arr.indexOf(t.value);
        if (t.checked && i < 0) arr.push(t.value); else if (!t.checked && i > -1) arr.splice(i, 1);
        st.page = 1; go();
      }
    });
    els.side.addEventListener('toggle', function (e) {
      var g = e.target.closest('.bb-s__group'); if (!g) return; openGroups[g.dataset.key] = g.open;
      if (g.open && BAR.matches) Array.prototype.forEach.call(els.side.querySelectorAll('.bb-s__group[open]'), function (o) { if (o !== g) { o.removeAttribute('open'); openGroups[o.dataset.key] = false; } });
      if (g.open && ALL_FACETS[g.dataset.key] && ALL_FACETS[g.dataset.key].lazy && last && !last.facetMap['__' + g.dataset.key]) loadFacet(g.dataset.key);
      if (g.open && g.dataset.key === 'within') { var wi = g.querySelector('input'); if (wi) wi.focus(); }
    }, true);
    function closePills() { if (!BAR.matches) return; Array.prototype.forEach.call(els.side.querySelectorAll('.bb-s__group[open]'), function (o) { o.removeAttribute('open'); openGroups[o.dataset.key] = false; }); }
    document.addEventListener('click', function (e) { if (!els.side.contains(e.target)) closePills(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePills(); });
    if (BAR.addEventListener) BAR.addEventListener('change', function () { openGroups = {}; load(); });
    els.side.addEventListener('input', debounce(function (e) {
      if (e.target.classList.contains('bb-s__facet-search')) { fq[e.target.dataset.fq] = e.target.value.trim(); if (ALL_FACETS[e.target.dataset.fq].lazy) loadFacet(e.target.dataset.fq); else load(); }
    }, 200));
    els.side.addEventListener('submit', function (e) {
      if (e.target.classList.contains('bb-s__within')) {
        e.preventDefault(); els.input.value = e.target.q.value; openGroups.within = false;
        els.form.dispatchEvent(new Event('submit', { cancelable: true })); return;
      }
      if (!e.target.classList.contains('bb-s__price')) return;
      e.preventDefault(); st.min = e.target.min.value; st.max = e.target.max.value; st.page = 1; go();
    });
    els.side.addEventListener('click', function (e) {
      var so = e.target.closest('[data-sort]');
      if (so) { openGroups.sort = false; st.sort = so.dataset.sort; st.page = 1; go(); return; }
      var b = e.target.closest('[data-more],[data-less]'); if (!b) return;
      if (b.dataset.more) showAll[b.dataset.more] = true; else showAll[b.dataset.less] = false;
      load();
    });
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.bb-s__chip');
      if (chip) {
        var k = chip.dataset.k, v = chip.dataset.v;
        if (k === 'q') { if (st.sort === defaultSort(st.q) || st.sort === 'relevance') st.sort = defaultSort(''); st.q = ''; } else if (k === 'instock') st.instock = false; else if (k === 'price') { st.min = ''; st.max = ''; }
        else st.f[k] = st.f[k].filter(function (x) { return x !== v; });
        st.page = 1; go(); return;
      }
      if (e.target.closest('.bb-s__clear')) {
        st.instock = false; st.min = ''; st.max = ''; fq = {}; if (IS_COLL && st.q) { st.q = ''; st.sort = defaultSort(''); } FACETS.forEach(function (f) { st.f[f.key] = []; }); st.page = 1; go(); return;
      }
      var pg = e.target.closest('[data-page]');
      if (pg) { e.preventDefault(); st.page = parseInt(pg.dataset.page, 10); go(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (e.target.closest('.bb-s__filter-toggle')) { root.classList.add('filters-open'); document.documentElement.classList.add('bb-s-lock'); return; }
      if (e.target.closest('.bb-s__drawer-close') || e.target.classList.contains('bb-s__shade')) { root.classList.remove('filters-open'); document.documentElement.classList.remove('bb-s-lock'); }
    });
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('.bb-s__add'); if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('button'), id = f.querySelector('[name="id"]').value, label = btn.textContent;
      btn.disabled = true;
      fetch((CFG.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
        .then(function () {
          btn.textContent = 'Added ✓'; btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:build'));
          setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-added'); }, 2000);
        }).catch(function (err) {
          btn.textContent = /stock|quantity|sold/i.test(err.message) ? 'No more available' : 'Try again';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
        });
    });
    window.addEventListener('popstate', function () { st = readState(); load(); });
    var desc = document.querySelector('.bb-c__desc');
    if (desc && desc.scrollHeight > desc.clientHeight + 4) {
      desc.classList.add('is-clamped');
      var more = document.createElement('button'); more.type = 'button'; more.className = 'text-link bb-c__more'; more.textContent = 'Read more';
      more.addEventListener('click', function () { desc.classList.remove('is-clamped'); desc.classList.add('is-open'); more.remove(); });
      desc.after(more);
    }
    load();
  }

  function init() { initPredictive(); initPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
